import memoize from "fast-memoize";
import { DataStore } from "../generic/DataStore";
import { PlayerContextState } from "../PlayerContext";

export class Storyline {
  name: string;
  // Order semantics
  // Generally 4 digit number.
  // Start with intended approximate progression location:
  // 1000 : before School Basement
  // 2000 : at School Basement
  // 3000 : at Living Forest
  // 4000 : at Thunder Tower
  // 5000 : at Elemental Dungeons
  // 6000 : at Palace of Darkness
  // 7000 : at Wizard's Arena
  // Increment by 10 per storyline "group" and by 1 per outcome on that
  // storyline.
  order: number;
  hintDescription: (state: PlayerContextState) => string;
  getBonusDescription: (state: PlayerContextState) => string;
  isBonusActive: (state: PlayerContextState) => boolean;
  isCompleted: (state: PlayerContextState) => boolean;
  isHintUnlockable: (state: PlayerContextState) => boolean;

  constructor(
    name: string,
    order: number,
    isCompleted: (state: PlayerContextState) => boolean,
    isBonusActive: (state: PlayerContextState) => boolean,
    hintDescription: string | ((state: PlayerContextState) => string),
    getBonusDescription: string | ((state: PlayerContextState) => string),
    isHintUnlockable: (state: PlayerContextState) => boolean,
  ) {
    this.name = name;
    this.order = order;
    this.isCompleted = isCompleted;
    this.isBonusActive = isBonusActive;
    this.hintDescription =
      typeof hintDescription === "string"
        ? (state) => hintDescription
        : hintDescription;
    this.getBonusDescription =
      typeof getBonusDescription === "string"
        ? (state) => getBonusDescription
        : getBonusDescription;
    this.isHintUnlockable = isHintUnlockable;
  }

  getId(): string {
    return this.name;
  }
}

const Storylines = new DataStore<Storyline>();

function _getSortedStorylines(): Storyline[] {
  return Storylines.getAll().sort((a, b) => a.order - b.order);
}

const getSortedStorylines = memoize(_getSortedStorylines);

export { Storylines, getSortedStorylines };
